import * as React from 'react';
import { type Category } from '@/types';
import { CategoryCard } from '../atoms/CategoryCard';

export interface CategoriesNavCardProps {
  categories?: Category[];
  onSelectCategory: (category: Category) => () =>void;
  selectedCategory: Category | null;
}

export function CategoriesNavCard(props: CategoriesNavCardProps) {

  if(!props.categories) {
    return null;
  }

  return (<div className="categories-nav-card">
      {props.categories.map((category) => (
        <CategoryCard 
          key={category.id} 
          category={category} 
          isSelected={props.selectedCategory?.id === category.id} 
          onClick={props.onSelectCategory(category)} 
        />
      ))}
  </div>)
}